export enum ToDoType {
	IMPORTANT = "IMPORTANT",
	VERY_IMPORTANT = "VERY_IMPORTANT",
}
